// extracted by mini-css-extract-plugin
export default {"main":"styles_main__bhrDl","container":"styles_container__Zsh7C","form":"styles_form__rzQFe","w100":"styles_w100__E-YwD","w50":"styles_w50__iwXq7","send":"styles_send__4FJe-"};